const toNonNegativeInteger = (value) => {
  const parsed = Number.parseInt(value, 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
};

export const getCountyCatalogCount = (currentUser, fallbackCount = 0) => {
  const countyCards = currentUser?.displays?.county_cards?.jur_us_fl;
  if (Array.isArray(countyCards) && countyCards.length > 0) {
    return countyCards.length;
  }

  return toNonNegativeInteger(fallbackCount);
};

export const getCountyAllowance = (currentUser, fallbackCatalogCount = 0) => {
  const planAllowance = toNonNegativeInteger(currentUser?.tier?.county);
  const legacyAdditions = toNonNegativeInteger(
    currentUser?.user?.analytics?.additions?.numCounties,
  );
  const purchasedExtras = toNonNegativeInteger(
    currentUser?.tier?.additions?.county?.qty,
  );
  const entitlement = planAllowance + legacyAdditions + purchasedExtras;
  const catalogCount = getCountyCatalogCount(currentUser, fallbackCatalogCount);

  return catalogCount > 0 ? Math.min(entitlement, catalogCount) : entitlement;
};

export const getCountiesRemaining = (allowance, selectedCount) =>
  Math.max(
    0,
    toNonNegativeInteger(allowance) - toNonNegativeInteger(selectedCount),
  );

export const isCountyLimitError = (error) => {
  const errorData = error?.response?.data;
  return (
    error?.response?.status === 400 &&
    (errorData?.code === "COUNTY_LIMIT_REACHED" ||
      errorData?.message === "County limit reached!")
  );
};
